export const UNGROUPED_SHOTS = 'ungrouped shots';
export const UNLOCATED_SHOTS = 'unlocated shots';
export const ALL_LOCATIONS = 'All locations';

export interface Location {
  name: string;
  shotIds: number[];
  previewFrame: number;
}
